export const route = { searchParams: { decline: 'decline' } };
